import * as React from 'react';
import { css, StyleSheet } from 'aphrodite-jss';
import { AspectRatioLayout } from '../layouts';
export class LoadingIndicator extends React.Component {
    render() {
        return (React.createElement("div", { className: this.containerClass },
            React.createElement(AspectRatioLayout, { whRatio: 1 },
                React.createElement("div", { className: css(this.styles.arcWrapper) },
                    React.createElement("div", { className: this.arcClass })))));
    }
    get containerClass() {
        return [this.props.className || '', css(this.styles.container)].join(' ');
    }
    get arcClass() {
        return [css(this.styles.arc), this.props.isWhite ? css(this.styles.arcWhite) : ''].join(' ');
    }
    get rotateKeyFrames() {
        return {
            '0%': {
                transform: 'rotate(0)',
            },
            '100%': {
                transform: 'rotate(360deg)',
            },
        };
    }
    get styles() {
        return StyleSheet.create({
            container: {
                display: 'inline-block',
                width: this.props.size,
            },
            arcWrapper: {
                position: 'relative',
                width: '100%',
                height: '100%',
                transform: `translate(-50%, -50%) scale(1) translate(50%, 50%)`,
            },
            arc: {
                position: 'absolute',
                width: '80%',
                height: '80%',
                top: '20%',
                left: '20%',
                borderRadius: '50%',
                border: `1px solid #000`,
                borderColor: `#65C3CA transparent #65C3CA transparent`,
                animationName: 'arc',
                animationDuration: '1s',
                animationTimingFunction: 'linear',
                animationIterationCount: 'infinite',
            },
            arcWhite: {
                borderColor: `#ffffff transparent #ffffff transparent`,
            },
            '@keyframes arc': this.rotateKeyFrames,
        });
    }
}
